"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var trans_1 = __importDefault(require("@/plugins/trans"));
var LocationAutocomplete_1 = __importDefault(require("../vacancies/LocationAutocomplete"));
var SearchVacanciesContext_1 = __importDefault(require("../context/SearchVacanciesContext"));
var SearchLocation = function () {
    var _a = (0, react_1.useContext)(SearchVacanciesContext_1.default), query = _a.query, updateQuery = _a.updateQuery;
    var handleLocationChange = (0, react_1.useCallback)(function (_a) {
        var lat = _a.lat, lng = _a.lng, incomingAddress = _a.incomingAddress;
        updateQuery({ lat: lat, lng: lng, address: incomingAddress });
    }, [updateQuery]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", sx: { color: '#fff', marginBottom: '4px' } }, { children: trans_1.default.get('labels.frontend.search.where.where') })), (0, jsx_runtime_1.jsx)(LocationAutocomplete_1.default, { onChange: handleLocationChange, initialValue: query === null || query === void 0 ? void 0 : query.address })] }));
};
exports.default = SearchLocation;
